import { MenuListResponse, MenuQueryParams, CreateMenuRequest, UpdateMenuRequest } from '@/types/menu';
import { API_ENDPOINTS, apiRequest } from '@/config/api';

// 构建查询参数
function buildQueryParams(params: MenuQueryParams): string {
  const searchParams = new URLSearchParams();

  if (params.page !== undefined) {
    searchParams.append('Page', params.page.toString());
  }
  if (params.pageSize !== undefined) {
    searchParams.append('PageSize', params.pageSize.toString());
  }

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
}

// 菜单管理相关API
export const menuApi = {
  // 获取菜单列表
  getMenuList: async (
    params: MenuQueryParams = {}
  ): Promise<MenuListResponse> => {
    const queryString = buildQueryParams(params);
    const response = await apiRequest<MenuListResponse>(
      `${API_ENDPOINTS.MENU_LIST}${queryString}`
    );

    console.log('Raw menu list API response:', response);

    // 直接返回完整响应
    if (response && typeof response === 'object') {
      return response;
    }

    // 如果响应格式不正确，返回默认值
    console.warn('Invalid response format, returning default');
    return {
      code: -1,
      msg: 'Invalid response',
      data: {
        list: []
      }
    };
  },

  // 创建菜单
  createMenu: async (
    data: CreateMenuRequest
  ): Promise<any> => {
    return apiRequest<any>(
      API_ENDPOINTS.MENU_CREATE,
      {
        method: 'POST',
        body: JSON.stringify(data)
      },
      '创建菜单失败'
    );
  },

  // 获取用户菜单功能
  getUserMenuFunction: async (): Promise<MenuListResponse> => {
    const response = await apiRequest<MenuListResponse>(
      API_ENDPOINTS.MENU_FUNCTION
    );

    console.log('User menu function API response:', response);

    // 直接返回完整响应
    if (response && typeof response === 'object') {
      return response;
    }

    // 如果响应格式不正确，返回默认值
    console.warn('Invalid response format, returning default');
    return {
      code: -1,
      msg: 'Invalid response',
      data: {
        list: []
      }
    };
  },

  // 更新菜单
  updateMenu: async (data: UpdateMenuRequest): Promise<any> => {
    return apiRequest<any>(
      API_ENDPOINTS.MENU_UPDATE,
      {
        method: 'POST',
        body: JSON.stringify(data)
      },
      '更新菜单失败'
    );
  },

  // 删除菜单
  deleteMenus: async (ids: number[]): Promise<any> => {
    return apiRequest<any>(
      API_ENDPOINTS.MENU_DELETE,
      {
        method: 'POST',
        body: JSON.stringify({ ids })
      },
      '删除菜单失败'
    );
  }
};

// 导出所有API
export const menuManagementApi = {
  menu: menuApi
};

// 默认导出
export default menuManagementApi;

